import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import ProjectValidator from "./ProjectValidator";

function ProjectRouter() {
  return (
    <Router>
      <Switch>
        <Route
          path={`${process.env.REACT_APP_ROUTE_PATH_PREFIX}/:project/:skipAC?/:possibleBundleId?`}
        >
          <ProjectValidator />
        </Route>
        <Route>
          <ProjectValidator />
        </Route>
      </Switch>
    </Router>
  );
}

export default ProjectRouter;
